// cSpell:disable
export const mockCity = 'Edinburgh';
export const mockCountry = 'UK';
export const mockState = 'London';
export const mockStreet = '511, Houston Street';
export const mockZipCode = '455372';
export const mockCompany = 'Intel';
export const mockDisplayNameOne = 'Jane Doe';
export const mockFirstName = 'Jane';
export const mockLastName = 'Doe';
export const mockEmail = 'jando567@gmail.com';
export const mockNumber1 = 'jando@intel.com';
export const mockNumber2 = '6647384294';
export const mockSipAddress = 'jando@go.webex.com';
export const mockTitle = 'Director';
export const mockGroupName = 'Other contacts';
export const mockAvatarURL = 'avatar-prod-us-east-2.webexcontent.com';

export const mockDisplayNameTwo = 'TestUser Webrtc';

export const mockContactResponseBodyOne = {
  contacts: [
    {
      avatarUrlDomain: 'avatar-prod-us-east-2.webexcontent.com',
      contactId: '801bb994-343b-4f6b-97ae-d13c91d4b877',
      contactType: 'CLOUD',
      encryptionKeyUrl: 'kms://cisco.com/keys/dcf18f9d-155e-44ff-ad61-c8a69b7103ab',
      groups: ['1561977e-3443-4ccf-a591-69686275d7d2'],
      isMigration: false,
      meta: {
        created: '2023-01-19T12:50:14.143Z',
        lastModified: '2023-01-19T12:50:14.143Z',
      },
      ownerId: '0fea4a63-4e27-46ee-99c3-2472cb12bf68',
      phoneNumbers: [
        {
          type: 'work',
          value:
            'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..RraxBTv0L-VBbmGE.zFMQZS7CCUIi4EizU5lVxixX.JVgGIpO8rU09Q3B97dwyRg',
        },
      ],
      sipAddresses: [
        {
          type: 'work',
          value:
            'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..RraxBTv0L-VBbmGE.zFMQZS7CCUIi4EizU5lVxixX.JVgGIpO8rU09Q3B97dwyRg',
        },
      ],
    },
    {
      addressInfo: {
        city: 'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..ZQxXkcSRHVhsETbD.Zf2jkBMa0h5W.bUt1XFfm4M9CaqVbj9WWgA',
        country:
          'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..8OINhXhrW34lhlFF.OA4.-wFSlsrC3yHZNroUXnImuQ',
        state:
          'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..K6xs8MriCqdaGpJk.78sgv9_J.A5Oa-Hx5XsTlE9tZtRvMVQ',
        street:
          'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..39gjK-W7rXZ_GBZ_.iJzt7VjyCVfxcZQ4Y8LvkEBN_g.3h5vu8Cnlx8ehucpxAjX2Q',
        zipCode:
          'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..Dl7IyKHvNAIDSVTg.ej2jYWdc.f35IB6Sdz2iffU-7C7ZhQQ',
      },
      avatarUrlDomain: 'avatar-prod-us-east-2.webexcontent.com',
      avatarURL:
        'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ',
      companyName:
        'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..hMSzGHFYnDFCRcGZ.B6-4afk.s8C-vpAM8ZnsBQ8e6BmmnQ',
      contactId: 'e04d14c7-5634-4905-bd81-dceb26fd71c8',
      contactType: 'CUSTOM',
      displayName:
        'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..euBLWhgFZtDPIZSP.u85IGF_bFs4.JUKLJPM6XeqV73iOOBt3qQ',
      emails: [
        {
          type: '',
          value:
            'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..RraxBTv0L-VBbmGE.zFMQZS7CCUIi4EizU5lVxixX.JVgGIpO8rU09Q3B97dwyRg',
        },
      ],
      encryptionKeyUrl: 'kms://cisco.com/keys/dcf18f9d-155e-44ff-ad61-c8a69b7103ab',
      firstName:
        'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..00Q0vBtHP7_24McS.erKMdg.7nKqyrz23Zf8ft2Admq7mg',
      groups: ['1561977e-3443-4ccf-a591-69686275d7d2'],
      isMigration: false,
      lastName:
        'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..In4w4TvDYbLZ4tZZ.zTjp.MC-iQU_s8wunkFreHycSnA',
      meta: {
        created: '2023-02-23T09:55:42.187Z',
        lastModified: '2023-02-23T09:55:42.187Z',
      },
      ownerId: '0fea4a63-4e27-46ee-99c3-2472cb12bf68',
      phoneNumbers: [
        {
          type: 'work',
          value:
            'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..evwrwHWw0tDHZVgg.bs3vlm3lNTmB0MqptY-n.zZpaZR_Mh6QgAb8y47nv8Q',
        },
        {
          type: 'mobile',
          value:
            'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..98aKiSjwP_pmwi4a.NccXQYx9dmN0nA.etk5jhGa9ec2oJBY9EASRQ',
        },
      ],
      sipAddresses: [
        {
          type: 'pmr',
          value:
            'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..nZli_KmAQ7sWwMtz.iaAgHmvx2LHfczsKQe9FX5QE.I34ILkYVxFt-dId-AGTulQ',
        },
      ],
      title:
        'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..RK42gA0wR7kiWCU0.4XgMGRT5v74.nn__qOr7oOdHLfbNzaZjeA',
    },
  ],
  groups: [
    {
      meta: {
        created: '2023-03-06T14:00:29.950Z',
        lastModified: '2023-03-06T14:00:29.951Z',
      },
      groupId: '1561977e-3443-4ccf-a591-69686275d7d2',
      groupType: 'NORMAL',
      ownerId: '08cedee9-296f-4aaf-bd4b-e14f2399abdf',
      displayName:
        'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..JP5o4Pe5KfAf8Wwh.Ww8JzimoaxCapUX1PqqJ8w.r8GtZLq6gOfCQIiTbs3Y2Q',
      members: ['e04d14c7-5634-4905-bd81-dceb26fd71c8', '801bb994-343b-4f6b-97ae-d13c91d4b877'],
      encryptionKeyUrl: 'kms://cisco.com/keys/dcf18f9d-155e-44ff-ad61-c8a69b7103ab',
      isMigration: false,
    },
  ],
};

export const mockContactResponseBodyTwo = {
  contacts: [
    {
      avatarUrlDomain: 'avatar-prod-us-east-2.webexcontent.com',
      contactId: '62de96be-fa97-4b4f-9106-76b267a87696',
      contactType: 'CUSTOM',
      displayName:
        'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..JP5o4Pe5KfAf8Wwh.Ww8JzimoaxCapUX1PqqJ8w.r8GtZLq6gOfCQIiTbs3Y2Q',
      encryptionKeyUrl: 'kms://cisco.com/keys/dcf18f9d-155e-44ff-ad61-c8a69b7103ab',
      groups: ['1561977e-3443-4ccf-a591-69686275d7d2'],
      ownerId: '0fea4a63-4e27-46ee-99c3-2472cb12bf68',
    },
  ],
  groups: [
    {
      meta: {
        created: '2023-03-06T14:00:29.950Z',
        lastModified: '2023-03-06T14:00:29.951Z',
      },
      groupId: '1561977e-3443-4ccf-a591-69686275d7d2',
      groupType: 'NORMAL',
      ownerId: '08cedee9-296f-4aaf-bd4b-e14f2399abdf',
      displayName:
        'eyJhbGciOiAiZGlyIiwgImtpZCI6ICJrbXM6Ly9jaXNjby5jb20va2V5cy9kY2YxOGY5ZC0xNTVlLTQ0ZmYtYWQ2MS1jOGE2OWI3MTAzYWIiLCAiZW5jIjogIkEyNTZHQ00ifQ..JP5o4Pe5KfAf8Wwh.Ww8JzimoaxCapUX1PqqJ8w.r8GtZLq6gOfCQIiTbs3Y2Q',
      members: ['62de96be-fa97-4b4f-9106-76b267a87696'],
      encryptionKeyUrl: 'kms://cisco.com/keys/dcf18f9d-155e-44ff-ad61-c8a69b7103ab',
      isMigration: false,
    },
  ],
};

export const mockContactResponseBodyThird = {
  contacts: [],
  groups: [],
  ownerId: '72574f1a-0158-4ffa-aab4-28bf3b488162',
};

export const mockContactListOne = [
  {
    addressInfo: {
      city: 'Edinburgh',
      country: 'UK',
      state: 'London',
      street: '511, Houston Street',
      zipCode: '455372',
    },
    avatarUrlDomain: 'avatar-prod-us-east-2.webexcontent.com',
    companyName: 'Intel',
    contactId: 'e04d14c7-5634-4905-bd81-dceb26fd71c8',
    contactType: 'CUSTOM',
    displayName: 'Jane Doe',
    emails: [{type: '', value: 'jando567@gmail.com'}],
    encryptionKeyUrl: 'kms://cisco.com/keys/dcf18f9d-155e-44ff-ad61-c8a69b7103ab',
    firstName: 'Jane',
    groups: ['1561977e-3443-4ccf-a591-69686275d7d2'],
    lastName: 'Doe',
    ownerId: '0fea4a63-4e27-46ee-99c3-2472cb12bf68',
    phoneNumbers: [
      {type: 'work', value: 'jando@intel.com'},
      {type: 'mobile', value: '6647384294'},
    ],
    sipAddresses: [{type: 'pmr', value: 'jando@go.webex.com'}],
    title: 'Director',
    isMigration: false,
    meta: {
      created: '2023-02-23T09:55:42.187Z',
      lastModified: '2023-02-23T09:55:42.187Z',
    },
    avatarURL: 'avatar-prod-us-east-2.webexcontent.com',
  },
  {
    avatarUrlDomain: 'avatar-prod-us-east-2.webexcontent.com',
    contactId: '801bb994-343b-4f6b-97ae-d13c91d4b877',
    contactType: 'CLOUD',
    department: '123029217',
    displayName: 'Emily Nagakawa',
    emails: [{value: 'emikawa2@cisco.com'}],
    encryptionKeyUrl: 'kms://cisco.com/keys/dcf18f9d-155e-44ff-ad61-c8a69b7103ab',
    firstName: 'Emily',
    groups: ['1561977e-3443-4ccf-a591-69686275d7d2'],
    lastName: 'Nagakawa',
    manager: 'Robert Langdon',
    ownerId: '0fea4a63-4e27-46ee-99c3-2472cb12bf68',
    phoneNumbers: [
      {type: 'mobile', value: '+1 835 648 8750'},
      {type: 'work', value: '+1 791 723 8825'},
      {type: 'work', value: mockNumber2},
    ],
    sipAddresses: [
      {type: 'cloud-calling', value: 'emikawa2@cisco.call.ciscospark.com', primary: true},
      {type: 'personal-room', value: 'emikawa2@cisco.webex.com', primary: false},
      {type: 'enterprise', value: 'emikawa2@cisco.com', primary: true},
      {type: 'personal-room', value: '25762555827@cisco.webex.com', primary: false},
      {type: 'work', value: mockSipAddress},
    ],
    title: 'Software Engineer',
    avatarURL: 'avatar-prod-us-east-2.webexcontent.com',
  },
];

export const mockContactListTwo = [
  {
    avatarUrlDomain: 'avatar-prod-us-east-2.webexcontent.com',
    contactId: '62de96be-fa97-4b4f-9106-76b267a87696',
    contactType: 'CUSTOM',
    displayName: 'TestUser Webrtc',
    encryptionKeyUrl: 'kms://cisco.com/keys/dcf18f9d-155e-44ff-ad61-c8a69b7103ab',
    groups: ['1561977e-3443-4ccf-a591-69686275d7d2'],
    ownerId: '0fea4a63-4e27-46ee-99c3-2472cb12bf68',
  },
];

export const mockContactGroupListOne = [
  {
    meta: {
      created: '2023-03-06T14:00:29.950Z',
      lastModified: '2023-03-06T14:00:29.951Z',
    },
    groupId: '1561977e-3443-4ccf-a591-69686275d7d2',
    groupType: 'NORMAL',
    ownerId: '08cedee9-296f-4aaf-bd4b-e14f2399abdf',
    displayName: 'Other contacts',
    members: ['e04d14c7-5634-4905-bd81-dceb26fd71c8', '801bb994-343b-4f6b-97ae-d13c91d4b877'],
    encryptionKeyUrl: 'kms://cisco.com/keys/dcf18f9d-155e-44ff-ad61-c8a69b7103ab',
    isMigration: false,
  },
];

export const mockContactGroupListTwo = [
  {
    meta: {
      created: '2023-03-06T14:00:29.950Z',
      lastModified: '2023-03-06T14:00:29.951Z',
    },
    groupId: '1561977e-3443-4ccf-a591-69686275d7d2',
    groupType: 'NORMAL',
    ownerId: '08cedee9-296f-4aaf-bd4b-e14f2399abdf',
    displayName: 'Other contacts',
    members: ['62de96be-fa97-4b4f-9106-76b267a87696'],
    encryptionKeyUrl: 'kms://cisco.com/keys/dcf18f9d-155e-44ff-ad61-c8a69b7103ab',
    isMigration: false,
  },
];

export const mockContactMinimum = {
  contactId: 'userId',
  contactType: 'CLOUD',
  encryptionKeyUrl: 'kms://cisco.com/keys/dcf18f9d-155e-44ff-ad61-c8a69b7103ab',
  groups: ['1561977e-3443-4ccf-a591-69686275d7d2'],
  ownerId: 'ownerId',
};

export const scimUserMinimum = {
  schemas: ['urn:ietf:params:scim:schemas:core:2.0:User'],
  id: 'userId',
  userName: 'userName',
  userType: 'user',
};

const scimUser1 = {
  schemas: [
    'urn:ietf:params:scim:schemas:core:2.0:User',
    'urn:scim:schemas:extension:cisco:webexidentity:2.0:User',
    'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User',
  ],
  id: 'userId',
  userName: 'johndoe@cisco.com',
  active: true,
  name: {
    familyName: 'Doe',
    givenName: 'John',
  },
  displayName: 'John Doe',
  emails: [
    {
      value: 'johndoe@cisco.com',
      type: 'work',
      primary: true,
    },
  ],
  userType: 'user',
  phoneNumbers: [
    {
      value: '+91 22 1234 5678',
      type: 'work',
    },
  ],
  photos: [
    {
      value: 'photoUrl',
      type: 'photo',
    },
    {
      value: 'thumbnailURL',
      type: 'thumbnail',
    },
  ],
  addresses: [
    {
      type: 'work',
      streetAddress: 'Street',
      locality: 'BANGALORE',
      region: 'KARNATAKA',
      postalCode: '560103',
      country: 'IN',
    },
  ],
  'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User': {
    department: '123029016',
    manager: {
      value: 'userId',
      displayName: 'Jane Smith',
      $ref: 'scimUrl',
    },
  },
  'urn:scim:schemas:extension:cisco:webexidentity:2.0:User': {
    isTeamsOnJabberEnabled: false,
    isUCCallOnJabberEnabled: false,
    licenseID: ['license'],
    userSettings: ['setting'],
    userPreferences: ['preferences'],
    sipAddresses: [
      {
        value: 'johndoe@cisco.call.ciscospark.com',
        type: 'cloud-calling',
      },
      {
        value: 'johndoe@cisco.calls.webex.com',
        type: 'cloud-calling',
        primary: true,
      },
      {
        value: 'johndoe@cisco.webex.com',
        type: 'personal-room',
      },
    ],
    meta: {
      organizationId: 'orgId',
    },
    userNameType: 'email',
  },
  meta: {
    resourceType: 'User',
    location: 'scimUrl',
    version: 'W/"16629124099"',
    created: '2019-12-24T02:01:42.803Z',
    lastModified: '2024-08-21T14:22:55.987Z',
  },
};

const scimUser2NoPhoto = {
  schemas: [
    'urn:ietf:params:scim:schemas:core:2.0:User',
    'urn:scim:schemas:extension:cisco:webexidentity:2.0:User',
    'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User',
  ],
  id: 'userId',
  userName: 'janedoe@cisco.com',
  active: true,
  name: {
    familyName: 'Doe',
    givenName: 'Jane',
  },
  displayName: 'Jane Doe',
  emails: [
    {
      value: 'janedoe@cisco.com',
      type: 'work',
      primary: true,
    },
  ],
  userType: 'user',
  phoneNumbers: [
    {
      value: '+91 22 1234 5678',
      type: 'work',
    },
  ],
  addresses: [
    {
      type: 'work',
      streetAddress: 'Street',
      locality: 'BANGALORE',
      region: 'KARNATAKA',
      postalCode: '560103',
      country: 'IN',
    },
  ],
  'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User': {
    department: '123029016',
    manager: {
      value: 'userId',
      displayName: 'John Smith',
      $ref: 'scimUrl',
    },
  },
  'urn:scim:schemas:extension:cisco:webexidentity:2.0:User': {
    isTeamsOnJabberEnabled: false,
    isUCCallOnJabberEnabled: false,
    licenseID: ['license'],
    userSettings: ['setting'],
    userPreferences: ['preferences'],
    sipAddresses: [
      {
        value: 'janedoe@cisco.call.ciscospark.com',
        type: 'cloud-calling',
      },
      {
        value: 'janedoe@cisco.calls.webex.com',
        type: 'cloud-calling',
        primary: true,
      },
      {
        value: 'janedoe@cisco.webex.com',
        type: 'personal-room',
      },
    ],
    meta: {
      organizationId: 'orgId',
    },
    userNameType: 'email',
  },
  meta: {
    resourceType: 'User',
    location: 'scimUrl',
    version: 'W/"16629124099"',
    created: '2019-12-24T02:01:42.803Z',
    lastModified: '2024-08-21T14:22:55.987Z',
  },
};

export const mockSCIMListResponse = {
  statusCode: 200,
  body: {
    schemas: ['urn:ietf:params:scim:api:messages:2.0:ListResponse'],
    totalResults: 2,
    itemsPerPage: 2,
    startIndex: 1,
    Resources: [scimUser1, scimUser2NoPhoto],
  },
};

export const mockSCIMMinListResponse = {
  statusCode: 200,
  body: {
    schemas: ['urn:ietf:params:scim:api:messages:2.0:ListResponse'],
    totalResults: 1,
    itemsPerPage: 1,
    startIndex: 1,
    Resources: [scimUserMinimum],
  },
};

export const mockKmsKey = {
  uri: 'kms://kms-cisco.wbx2.com/keys/16095024-612d-4424-ba51-57cad2402e14',
};
/* cSpell:enable */
